import * as React from 'react';
import PhoneInput from './PhoneInput';
import LinkButton from './LinkButton';
import '../css/addPayment.sass';
import { RulesMessages } from '../utils/validator';
import Formatter from './Formatter';

interface PhoneProps {
  differentNumberLabel?: string;
  addPhoneLink?: string;
  rulesMessages?: { [key: string]: RulesMessages };
  displayDetails?: boolean;
  newPhoneLabel?: string;
  onAddPhone: (phoneNumber: string) => void;
}

export default function NewPhoneNumber(props: PhoneProps) {
  const {
    displayDetails = false,
    differentNumberLabel = 'Different Number',
    newPhoneLabel = 'New Phone Number',
    addPhoneLink = 'Use Number'
  } = props;
  const [state, setState] = React.useState({
    phoneNumber: ''
  });

  return (
    <div className="addPayment">
      {displayDetails && (
        <>
          <div>{differentNumberLabel}</div>
          <div className="endingWith">
            {!!state.phoneNumber && (
              <span className="cardDetails">
                {' '}
                <Formatter
                  format="phone"
                  type="text"
                  value={state.phoneNumber}
                />
              </span>
            )}
          </div>
          <div className="hr">&nbsp;</div>
        </>
      )}
      <div>
        <PhoneInput
          required
          name="phoneNumber"
          id="phoneNumber"
          label={newPhoneLabel}
          rulesMessages={props.rulesMessages && props.rulesMessages.phone}
          hasError={false}
          onError={() => {
            setState({ ...state, phoneNumber: '' });
          }}
          onChange={(event: any) => {
            setState({ ...state, phoneNumber: event.target.value });
          }}
        />
      </div>

      <div style={{ textAlign: 'right' }}>
        <LinkButton
          name="addPhone"
          id="addPhone"
          smol
          disabled={!state.phoneNumber}
          onClick={() => {
            props.onAddPhone(state.phoneNumber);
          }}
        >
          {addPhoneLink}
        </LinkButton>
      </div>
    </div>
  );
}
